import {
  Box,
  FeaturedIcons,
  FiSlash,
  Flex,
  Tab,
  Tooltip,
} from '@agrotoken-tech/ui';
import { getPledgeSectionIconAndVariant } from '@bcba/frontend-utils';
import { useTranslation } from '@bcba/react-hooks';
import {
  CROP_PLEDGE_USER_ROLES,
  CropPledgeUserRole,
  PLEDGE_SECTION_STATUSES,
  PledgeSectionStatus,
} from '@bcba/types';
import { PropsWithChildren } from 'react';

interface CropPledgeAsideTabData extends PropsWithChildren {
  status?: PledgeSectionStatus;
  isDisabled?: boolean;
  cropPledgeUserRole?: CropPledgeUserRole;
}

export const CropPledgeAsideTab = ({
  children,
  status = PLEDGE_SECTION_STATUSES.PENDING_DEBTOR_LOAD,
  isDisabled,
  cropPledgeUserRole = CROP_PLEDGE_USER_ROLES.CREDITOR,
}: CropPledgeAsideTabData) => {
  const { t } = useTranslation();
  const statusLabel = status ? t(`cropPledge.statusSection.${status}`) : '';
  const { iconByStatus, variant } = getPledgeSectionIconAndVariant(
    status,
    cropPledgeUserRole,
  );

  return (
    <Tab
      justifyContent={'start'}
      border={'none'}
      py={3}
      isDisabled={isDisabled}
    >
      {isDisabled ? (
        <Flex gap={2} alignItems={'center'}>
          <Tooltip
            hasArrow
            label={t('cropPledge.section.disabled.tooltip')}
            title={t('cropPledge.section.disabled.tooltip')}
            placement="bottom"
            bg="white"
            color="content-secondary"
            size="sm"
            minW={'auto'}
          >
            <Box>
              <FeaturedIcons icon={FiSlash} variant="disabled" size="sm" />
            </Box>
          </Tooltip>
          {children}
        </Flex>
      ) : (
        <Flex gap={2} alignItems={'center'}>
          <Tooltip
            hasArrow
            label={statusLabel}
            title={statusLabel}
            placement="bottom"
            bg="white"
            color="content-secondary"
            size="sm"
            minW={'auto'}
          >
            <Box>
              {status ? (
                <FeaturedIcons
                  icon={iconByStatus}
                  variant={variant as any}
                  size="sm"
                />
              ) : null}
            </Box>
          </Tooltip>
          {children}
        </Flex>
      )}
    </Tab>
  );
};
